import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { CryptoWhitelist, ErrorResponse, ListResponse } from 'types';

const useCryptoWhiteList = ({
  queries,
  enabled,
}: {
  queries: {
    transaction_method?: string;
    wallet?: string;
  };
  enabled?: boolean;
}): UseQueryResult<ListResponse<CryptoWhitelist>, ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.cryptoWhitelist}${queryParams}`], {
    enabled: enabled,
  });
};
export default useCryptoWhiteList;
